import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import ProductCard from "../components/ProductCard";

const SORTS = [
  { v: "newest", l: "Cele mai noi" },
  { v: "price_asc", l: "Preț crescător" },
  { v: "price_desc", l: "Preț descrescător" },
];

export default function Shop() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const cat = params.get("category") || "";
  const search = params.get("search") || "";
  const sort = params.get("sort") || "newest";
  const rare = params.get("rare") === "true";
  const trending = params.get("trending") === "true";
  const minP = params.get("min_price") || "";
  const maxP = params.get("max_price") || "";

  useEffect(() => {
    api.get("/products/categories/list").then(r => setCategories(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const q = {};
    if (cat) q.category = cat;
    if (search) q.search = search;
    if (sort) q.sort = sort;
    if (rare) q.rare = true;
    if (trending) q.trending = true;
    if (minP) q.min_price = minP;
    if (maxP) q.max_price = maxP;
    api.get("/products", { params: q }).then(r => setProducts(r.data)).finally(() => setLoading(false));
  }, [cat, search, sort, rare, trending, minP, maxP]);

  const setParam = (k, v) => {
    const np = new URLSearchParams(params);
    if (v === "" || v == null || v === false) np.delete(k);
    else np.set(k, v);
    setParams(np);
  };

  return (
    <main className="pt-32 pb-20" data-testid="shop-page">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <header className="mb-16 text-center">
          <p className="label-luxe text-[#D4AF37] mb-3">Magazin</p>
          <h1 className="h-display text-5xl sm:text-7xl text-[#F8F4E6]">{cat || "Întreaga Colecție"}</h1>
          {search && <p className="mt-4 text-[#A39E8A]">Rezultate pentru: <span className="text-[#D4AF37]">{search}</span></p>}
        </header>

        <div className="grid lg:grid-cols-[260px_1fr] gap-12">
          {/* FILTERS */}
          <aside className="space-y-8" data-testid="filters">
            <div>
              <p className="label-luxe mb-4">Categorii</p>
              <ul className="space-y-2">
                <li>
                  <button onClick={() => setParam("category", "")} className={`text-sm transition ${!cat ? "text-[#D4AF37]" : "text-[#A39E8A] hover:text-[#F8F4E6]"}`} data-testid="filter-all">Toate</button>
                </li>
                {categories.map(c => (
                  <li key={c}>
                    <button onClick={() => setParam("category", c)} className={`text-sm transition ${cat === c ? "text-[#D4AF37]" : "text-[#A39E8A] hover:text-[#F8F4E6]"}`} data-testid={`filter-${c.replace(/\s+/g,"-")}`}>{c}</button>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="label-luxe mb-4">Preț (lei)</p>
              <div className="flex gap-2">
                <input type="number" placeholder="Min" value={minP} onChange={e => setParam("min_price", e.target.value)} className="input-luxe" data-testid="min-price" />
                <input type="number" placeholder="Max" value={maxP} onChange={e => setParam("max_price", e.target.value)} className="input-luxe" data-testid="max-price" />
              </div>
            </div>
            <div>
              <p className="label-luxe mb-4">Tip</p>
              <label className="flex items-center gap-3 text-sm text-[#A39E8A] cursor-pointer">
                <input type="checkbox" checked={rare} onChange={e => setParam("rare", e.target.checked || "")} className="accent-[#D4AF37]" data-testid="filter-rare" />
                Doar piese rare
              </label>
              <label className="flex items-center gap-3 text-sm text-[#A39E8A] mt-2 cursor-pointer">
                <input type="checkbox" checked={trending} onChange={e => setParam("trending", e.target.checked || "")} className="accent-[#D4AF37]" data-testid="filter-trending" />
                În tendințe
              </label>
            </div>
          </aside>

          {/* GRID */}
          <section>
            <div className="flex justify-between items-center mb-8 pb-4 border-b border-[#D4AF37]/15">
              <span className="text-sm text-[#A39E8A]">{products.length} obiecte</span>
              <select value={sort} onChange={e => setParam("sort", e.target.value)} className="bg-transparent text-sm text-[#F8F4E6] border border-[#D4AF37]/30 px-3 py-2 outline-none" data-testid="sort-select">
                {SORTS.map(s => <option key={s.v} value={s.v} className="bg-[#0F0F0F]">{s.l}</option>)}
              </select>
            </div>
            {loading ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {[...Array(6)].map((_, i) => <div key={i} className="aspect-[4/5] bg-[#0F0F0F] shimmer-gold" />)}
              </div>
            ) : products.length === 0 ? (
              <div className="text-center py-32">
                <p className="font-serif text-3xl text-[#A39E8A]">Niciun obiect găsit</p>
              </div>
            ) : (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {products.map((p, i) => <ProductCard key={p.id} product={p} idx={i} />)}
              </div>
            )}
          </section>
        </div>
      </div>
    </main>
  );
}
